<div class="program_page">
	<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
	<div class="program_page_container">
		<app-header [isPreview]="isPreview" (closeProgramModalEvent)="captureProgramModalCloseEvent($event)" [showBackButtonBlack]="showBackButtonBlack" [headerTitle]="headerTitle"></app-header>
		<div *ngIf="selectedSection">
			<div class="header_row">
				<div class="streak_container_main">
					<img class="design_header_img" src="../../assets/images/dashboard_images/Group 8.svg" alt="">
					<span class="streak_container">{{ daysInRow + ' Day Streak!'}}</span>
				</div>
				<div class="upnext_container">
					Up Next > <span class="bold_text"> {{ getNextSectionName() }}</span>
				</div>
			</div>

			<!-- <div class="days_container">
								<div class="days_name">
									<div class="top_date_bar"
										[ngClass]="{'target_green': dfsDay.isDfsCompleted, 'target_grey': !dfsDay.isDfsCompleted, 'active_day': dfsDay.firstIncompleteDfs, 'screen_open_gif': dfsDay.firstIncompleteDfs && showScreenOpenGif, 'new_section_gif': dfsDay.firstIncompleteDfs && showNewSectionGif, 'celebration_gif': dfsDay.firstIncompleteDfs && showCelebrationGif }"
										*ngFor="let dfsDay of targetDfsLabels">
									</div>
								</div>
					</div> -->

			<div class="program_page_content_container">
				<div [ngClass]="{'isTranscriptActiveClass': isTranscript}" class="left_container">
					<div class="days_container">
						<div class="days_name">
							<div class="top_date_bar"
								[ngClass]="{ 'target_green': dfsDay.isDfsCompleted, 'target_grey': !dfsDay.isDfsCompleted, 'gifSize': dfsDay.firstIncompleteDfs }"
								*ngFor="let dfsDay of targetDfsLabels; let i = index">
								<span *ngIf="i !== targetDfsLabels.length - 1">
									<img *ngIf="dfsDay.firstIncompleteDfs && showBlinkGif"
										src="../../assets/gifs/Flip_Blink_pose.gif">
									<img *ngIf="dfsDay.firstIncompleteDfs && showScreenOpenGif"
										src="../../assets/gifs/Flip_hands_wink_wave_pose.gif">
									<img *ngIf="dfsDay.firstIncompleteDfs && showNewSectionGif"
										src="../../assets/gifs/Flip_hands_wink_wave_pose.gif">
									<img *ngIf="dfsDay.firstIncompleteDfs && showCelebrationGif"
										src="../../assets/gifs/Flip_Hands_Up_Happy_pose.gif">
								</span>

								<span *ngIf="i === targetDfsLabels.length - 1">
									<span *ngIf="userProgress.progress !== 100">
										<img *ngIf="dfsDay.firstIncompleteDfs && showBlinkGif"
											src="../../assets/gifs/Flip_Blink_pose.gif">
										<img *ngIf="dfsDay.firstIncompleteDfs && showScreenOpenGif"
											src="../../assets/gifs/Flip_hands_wink_wave_pose.gif">
										<img *ngIf="dfsDay.firstIncompleteDfs && showNewSectionGif"
											src="../../assets/gifs/Flip_hands_wink_wave_pose.gif">
										<img *ngIf="dfsDay.firstIncompleteDfs && showCelebrationGif"
											src="../../assets/gifs/Flip_Hands_Up_Happy_pose.gif">
									</span>

									<span *ngIf="userProgress.progress === 100">
										<img src="../../assets/gifs/Flip_Hands_Up_Happy_pose.gif"
											*ngIf="showCelebrationGif" class="largeGif">
										<img src="../../assets/gifs/Flip_Blink_pose.gif" *ngIf="showBlinkGif"
											class="largeGif">
									</span>
								</span>
							</div>
						</div>
						<div class="menu_btn" (click)="showProgramMenu()">
							<mat-icon>menu</mat-icon>
						</div>
					</div>
					<div class="opacity"></div>
					<div
						*ngIf="selectedSection && (selectedSection.type === 'video' || selectedSection.type === 'Video')">

						<div class="details">
							<p class="left_container_head">{{ selectedSection.name }} <span *ngIf="!selectedSection.videoType">- {{ sectionName }}</span></p>

							<div class="details_2">
								<vg-player class="btnn btnn-default" [ngClass]="{ transparentBg: !videoPaused }"
									#myPlayer>

									<!-- <div class="like-comment-icons-box">
										<mat-icon class="like-icon" [ngClass]="{'active': isVideoLiked}" (click)="likeVideoFn(isVideoLiked ? 'unlike' : 'like')">favorite</mat-icon>
										<mat-icon class="comment-icon" [ngClass]="{'active': isCommentBoxOpen}" (click)="toggleCommentBox()">comment</mat-icon>
									</div>
									<div *ngIf="isCommentBoxOpen" class="like-comment-box">
										<div class="comment-box">
											<div class="c-inner-box">
												<div class="close-icon">
													<mat-icon (click)="toggleCommentBox()">close</mat-icon>
												</div>
												<div class="top-title-btn">
													<div class="title">Write Comments</div>
													<button class="btn" (click)="commentSubmit()">Save</button>
												</div>
												<textarea name="" id="comment-box-textarea" [(ngModel)]="commentText"></textarea>
												<ul class="more-comments">
													<li *ngFor="let comment of videoComments">
														<div class="comment">
															<span class="c-text">{{comment.text}}</span>
															<span class="c-time">{{comment.formattedTime}}</span>
														</div>
													</li>
												</ul>
											</div>
										</div>
									</div> -->

									<vg-controls [vgAutohide]="true" [vgAutohideTime]="1">
										<div (click)="tenSecondsBack()" class="prevArrow">
											<img class="replay" src="../../assets/images/ten.png" alt="">
										</div>

										<vg-play-pause></vg-play-pause>

										<!-- <div (click)="playNext()" style=" margin-right: 10px;"><img src="../../assets/images/nextv.svg" alt=""></div> -->

										<vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
										<vg-scrub-bar id="scrub-bar">
											<vg-scrub-bar-current-time></vg-scrub-bar-current-time>
											<vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
											<!-- <div class="invisible_sec" (mousedown)="preventScrubBarClick($event)"></div> -->
										</vg-scrub-bar>

										<span class="video-remaining-time">{{ displayVideoTimeLeft() }}</span>

										<!-- <vg-mute id="muteBtn"></vg-mute> -->

										<div class="volume_btn volume_btn_img">
											<div class="volume_btn_img" (click)="muteBtnClick('mute')"
												*ngIf="!isVideoMuted(); else videoMuted">
												<img src="../../assets/images/vol.png" alt="">
											</div>

											<ng-template #videoMuted>
												<div class="volume_btn_img" (click)="muteBtnClick('unmute')">
													<img src="../../assets/images/mute.png" alt="">
												</div>
											</ng-template>

											<mat-slider class="volume_slider" min="0.0" max="1.0" step="0.1"
												[value]="videoVolume" vertical (change)="volumeSliderChange($event)">
												<!-- <input matSliderThumb [(ngModel)]="videoVolume"> -->
											</mat-slider>
										</div>

										<!-- <div clickOutside (clickOutside)="clickedOutside()" class="volume_btn">
															<img (click)="showVol = !showVol" src="../../assets/images/volume-up.png" alt=""
																class="vol">
												</div> -->

										<!-- <div class="volume" > -->
										<!-- <ngx-slider class="volume" *ngIf="showVol" [(value)]="value" [options]="options"></ngx-slider> -->
										<!-- </div> -->

										<vg-fullscreen></vg-fullscreen>
									</vg-controls>

									<video oncontextmenu="return false;" (keydown)="handleKeyDown($event)" tabindex="0" [vgMedia]="$any(master)" #master [vgMaster]="true" id="masterVideo"
										preload="auto" (play)="videoPaused = false" (pause)="videoPaused = true"
										[poster]="getSectionPoster()">
										<source [src]="videoLocation" type="video/mp4" id="videoSource">
									</video>
								</vg-player>

								<div class="video_details">

									<!-- <div class="vdieo_details_row">
														<div style="padding-left: 0px !important" class="sec_name">{{ sectionName }}</div>
														<div class="language_dropdown">
															<img class="dropdown_arrow" src="../../assets/images/down.png" alt="">
															<mat-form-field appearance="fill">
																<mat-label>English</mat-label>
																<mat-select [value]="">
																	<mat-option class="lang"
																		*ngFor="let language of languages | orderBy:'brand'"
																		[value]="language.language">
																		{{ language.language }}
																	</mat-option>
																</mat-select>
															</mat-form-field>
														</div>
													</div> -->

									<div class="description">
										{{ sectionDescription }}
									</div>

								</div>
							</div>


						</div>
					</div>

					<div
						*ngIf="selectedSection && (selectedSection.type === 'quiz' || selectedSection.type === 'Quiz') && selectedSection.quizType !== 'ispring quiz'">
						<div class="quiz_data">
							<div class="quiz_name">{{ selectedSection.name }}</div>
							<form class="quiz_form"
								*ngIf="!isSectionCompleted(selectedSection.sno, userProgress.sections); else restartQuiz">
								<!-- <mat-horizontal-stepper>
										<mat-step -->
								<div
									*ngFor="let question of selectedSection.metadata.questions; let i = index; let lastQuestion = last;">

									<ng-template matStepLabel> {{ i + 1 }}</ng-template>

									<!-- <ng-template matStepLabel>{{ question.label }}</ng-template> -->

									<label id="example-radio-group-label" *ngIf="question.text !== ''">
										<div class="question_container">
											<div class="question_number">Question {{ i + 1 }}:</div>
											<div class="question">
												{{ question.text }}
											</div>
										</div>
									</label>

									<div class="question_li" *ngIf="question.text !== ''">
										<ul class="ordered_list"
											*ngIf="!question.type || question.type === '1' || question.type === '2'">
											<mat-radio-group (change)="selectRadioOption($event, i, question.type)">
												<li class="ques_option"
													*ngFor="let option of question.options; let optionIndex = index">
													<mat-radio-button [value]="optionIndex" *ngIf="option.text !== ''">
														{{ option.text }}
													</mat-radio-button>
												</li>
											</mat-radio-group>
										</ul>

										<ul class="ordered_list checkboxes_list" *ngIf="question.type === '3'">
											<li class="ques_option checkboxes_list_options"
												*ngFor="let option of question.options; let optionIndex = index">
												<mat-checkbox (change)="selectOption($event, optionIndex, i)"
													*ngIf="option.text !== ''">
													{{ option.text }}
												</mat-checkbox>
											</li>
										</ul>
									</div>
									<!-- <button *ngIf="lastQuestion" class="btn submit_btn"
										[disabled]="shouldSubmitBeDisabled()" (click)="submitQuiz()">Submit</button> -->
									<button *ngIf="lastQuestion" class="btn submit_btn" (click)="submitQuiz()"
										[disabled]="shouldSubmitBeDisabled()">Submit</button>
									<!-- <div class="buttons">
												<button *ngIf="i !== 0" matStepperPrevious class="btn back_btn"
													type="button" (click)="prevStep(i)"><span class="prev_icon"><img
															src="../../assets/images/backbtn.svg" alt=""></span>
													Previous</button>
												<button *ngIf="!lastQuestion" matStepperNext class="btn nextBtn"
													type="button" (click)="nextStep(i)">Next <img
														src="../../assets/images/nextbtn.svg" alt=""></button>
												<button *ngIf="lastQuestion" class="btn submit_btn"
													[disabled]="shouldSubmitBeDisabled()"
													(click)="submitQuiz()">Submit</button>
											</div> -->
								</div>
								<!-- </mat-step>
									</mat-horizontal-stepper> -->

								<div class="quiz_img_container">
								</div>
							</form>

							<ng-template #restartQuiz>
								<div class="already_attempted_quiz_container">
									<div class="head" *ngIf="getQuizPercentage(selectedSection.sno,
										userProgress.sections) !== 100; else perfectScore">You have attempted this quiz.</div>
									<ng-template #perfectScore>
										<div class="head" style="font-size: 20px; text-align: center">
											Perfect Score!
										</div>
									</ng-template>
									<div class="score_container">

										<div class="progressBar">
											<!-- <img src="../../assets/images/School Book Trophy.svg" alt="" class="circle_prog_img"> -->
											<!-- [outerStrokeGradient]=true -->
											<!-- [outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
												[percent]="getQuizPercentage(selectedSection.sno, userProgress.sections)"
												[outerStrokeColor]="'#000000'" [innerStrokeColor]="'#ffffff'"
												[outerStrokeWidth]="34" [innerStrokeWidth]="13"
												[titleFontSize]="'0'" [unitsFontSize]="'0'" [subtitleFontSize]="'0'"
												[titleFontWeight]="'600'" [unitsFontWeight]="'600'"
												[subtitleFontWeight]="'500'" [radius]="100"
												[outerStrokeLinecap]="'circle'" [space]="-18.9"
												[titleColor]="'#000000'" [unitsColor]="'#000000'"
												[titleFontWeight]="'600'" -->

											<circle-progress [outerStrokeGradient]=true
												[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
												[percent]="getQuizPercentage(selectedSection.sno, userProgress.sections)"
												[outerStrokeColor]="'#8aead0'" [innerStrokeColor]="'#000000'"
												[outerStrokeWidth]="19" [innerStrokeWidth]="13" [titleFontSize]="'0'"
												[unitsFontSize]="'0'" [subtitleFontSize]="'0'" [titleFontWeight]="'600'"
												[unitsFontWeight]="'600'" [subtitleFontWeight]="'500'" [radius]="60"
												[outerStrokeLinecap]="'circle'" [space]="-18.9" [titleColor]="'#000000'"
												[unitsColor]="'#000000'" [titleFontWeight]="'600'"></circle-progress>
											<h2 class="progress_head2">{{ getQuizPercentage(selectedSection.sno,
												userProgress.sections) }} %</h2>
											<!-- <p class="pending3">{{ activeProgramComment(userProgress.progress) }}
												</p> -->
										</div>

										<!-- <div>
														<img src="../../assets/images/grade (1) 1.svg" alt=""><span class="score">
															Your Score :</span>
														<span class="score_numb">
															{{ getQuizPercentage(selectedSection.sno, userProgress.sections) }}%
														</span>
													</div>

													<div>
														<span class="score"> Points Earned :
														</span>
														<span class="score_numb">{{ getQuizScore(selectedSection.sno,
															userProgress.sections) }}
														</span>
													</div> -->
									</div>

									<div class="quiz_buttons">
										<button class="restart_btn" style="color: black;"
											(click)="restartQuizButton(userProgress.sections)">Restart
											Quiz</button>

										<button class="restart_btn nextD" (click)="moveToNextSection()"
											*ngIf="!isLastSection()">Next D.O.S.E
										</button>
									</div>

								</div>
							</ng-template>
						</div>
					</div>

					<div class="ispring-quiz-wrapper" *ngIf="selectedSection?.quizType === 'ispring quiz' && selectedSection && (selectedSection.type === 'quiz' || selectedSection.type === 'Quiz')">
						<div class="ispring-quiz" *ngIf="!isSectionCompleted(selectedSection.sno, userProgress.sections); else restartIspringQuiz">
							<iframe *ngIf="ispringQuizIframeUrl" width="100%" height="100%" [src]="ispringQuizIframeUrl | safe: 'url'" frameborder="0"></iframe>
						</div>

						<ng-template #restartIspringQuiz>
							<div class="already_attempted_quiz_container ispring_result">
								<div class="head" *ngIf="getQuizPercentage(selectedSection.sno, userProgress.sections) !== 100; else perfectScore">You have attempted this quiz.</div>
								<ng-template #perfectScore>
									<div class="head" style="text-align: center">
										Perfect Score!
									</div>
								</ng-template>
								<div class="score_container">
									<div class="progressBar">
										<circle-progress [outerStrokeGradient]=true
											[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
											[percent]="getQuizPercentage(selectedSection.sno, userProgress.sections)"
											[outerStrokeColor]="'#8aead0'" [innerStrokeColor]="'#000000'"
											[outerStrokeWidth]="26" [innerStrokeWidth]="18" [titleFontSize]="'0'"
											[unitsFontSize]="'0'" [subtitleFontSize]="'0'" [titleFontWeight]="'600'"
											[unitsFontWeight]="'600'" [subtitleFontWeight]="'500'" [radius]="100"
											[outerStrokeLinecap]="'circle'" [space]="-18.9" [titleColor]="'#000000'"
											[unitsColor]="'#000000'" [titleFontWeight]="'600'"></circle-progress>
										<h2 class="progress_head2 ispring_result_percent">{{ getQuizPercentage(selectedSection.sno, userProgress.sections) }} %</h2>
									</div>
								</div>

								<div class="quiz_buttons">
									<button class="restart_btn" style="color: black;" (click)="restartQuizButton(userProgress.sections)">Restart Quiz</button>
									<button class="restart_btn nextD" (click)="moveToNextSection()" *ngIf="!isLastSection()">Next D.O.S.E</button>
								</div>
							</div>
						</ng-template>
					</div>

					<div
						*ngIf="selectedSection && (selectedSection.type === 'download' || selectedSection.type === 'Download')">
						<div id="downloadSection" class="download_container">

							<div class="upper_sec">
								<div class="download_left">
									<h5>DOWNLOAD Time!</h5>
									<p class="proceed">
										So you can proceed, be <br> sure to <span>download</span> your <br> <span>document
											first</span> then <br> return to this window to <br> keep learning
									</p>

									<p class="zeromargin"
										*ngIf="getTaskStatus(selectedSection.sno, userProgress.sections).status !== 'task_completed_line'">
										<!-- Please note that
											you need to download these document(s) for proceeding to the next section -->

									</p>
									<button class="download-doc-btn"
											(click)="downloadDocument(selectedSection.dfs, selectedSection.metadata.documents[0].link, 0)">Download
											Here</button>
								</div>

								<div class="download_right">
									<ng-container #iframeContainer
										*ngFor="let document of selectedSection.metadata.documents; let i = index"
										id="embedprnt" #embedprnt class="pdf-container">
										<img class="downloadImg" [ngClass]="{'landscapeImage': document.landscapeImage, 'portraitImage' : document.portraitImage, 'notImage': !(document.landscapeImage || document.portraitImage)}" [src]="(document.landscapeImage || document.portraitImage) ? (document.landscapeImage ? document.landscapeImage : document.portraitImage) : '../../../../../assets/images/default-download.webp'"
										alt="">
										<!-- <button class="download-doc-btn"
											(click)="downloadDocument(selectedSection.dfs, document.link, i)">Download
											Here</button> -->
									</ng-container>
								</div>
							</div>

							<div class="next_dose_btn_box">
								<!-- <div class="emptyDiv"></div> -->
								<button class="restart_btn nextD nxt" id="next-dose-btn-download"
									(click)="moveToNextSection()">Next D.O.S.E
								</button>
							</div>
						</div>
					</div>

				</div>

				<!-- <div class="menu_btn" (click)="showProgramMenu()">
					<mat-icon>menu</mat-icon>
				</div> -->

				<div *ngIf="showSideMenu" class="right_container">
					<div class="mobile-cross" (click)="showProgramMenu()">
						X
					</div>
					<div class="right_inner-container">

						<div class="prog_details">
							<div class="prog_name">Progress
								<div class="progress_percentage">
									{{ isPreview ? 100 : userProgress.progress }}%
								</div>
							</div>
							<div class="complete progress">
								<div role="progressbar" class="progress-bar" style.width="{{ userProgress.progress }}%"
									aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
								</div>
							</div>

							<div class="total_time" *ngIf="userProgress && userProgress.courseTime">Total time: {{
								getFormattedCourseTime(userProgress.courseTime) }}</div>
						</div>

						<!-- <ngb-accordion class="accordion" [closeOthers]="true" activeIds="static-1">
											<ngb-panel id="static-1">
												<ng-template ngbPanelTitle>
													<div style="display: flex; color: white;
														place-items: center;"><span style="font-family: 'Material Symbols Rounded' !important;
															margin-right: 10px;
															font-size: 24px;
																margin-left: -6px;" class="material-symbols-rounded">
															play_arrow
														</span> {{ programName }}</div>

												</ng-template>
												<ng-template ngbPanelContent> -->
						<!-- <article class="sample-wrapper">
														<div class="left_border"></div> -->
						<ngb-accordion [closeOthers]="true" #accordion style="margin-left: 0px;"
							[activeIds]="accordionActiveIds">
							<ngb-panel *ngFor="let section of dataForMenu.sections" [id]="section.sno"
								class="expansion-panel-element">
								<!-- <igx-expansion-panel-header> -->
								<!-- <igx-expansion-panel-title> -->
								<ng-template ngbPanelTitle>
									<div *ngIf="userProgress; else noProgress">
										<div class="sec_name sec_name_main"
											[ngClass]="getTaskStatus(section.sno, this.userProgress.sections).status">
											<span
												style="color: white; font-family: 'Material Symbols Rounded' !important; margin-right: 8px; font-size: 30px; margin-left: -12px;"
												class="material-symbols-rounded arr">
											</span> {{ section.name }}
											<!-- <span *ngIf="isSectionCompleted(section.sno, this.userProgress.sections)" class="completion-icon">&#10003;</span> -->
										</div>
									</div>

									<ng-template #noProgress>
										<div class="sec_name">
											<span
												style="font-family: 'Material Symbols Rounded' !important; margin-right: 10px; font-size: 20px; color: white; margin-left: -6px;"
												class="material-symbols-rounded">
											</span> {{ section.name }}
										</div>
									</ng-template>
								</ng-template>

								<!-- </igx-expansion-panel-title> -->
								<!-- </igx-expansion-panel-header> -->

								<!-- <igx-expansion-panel-body> -->

								<ng-template ngbPanelContent>
									<div class="unit_content_list_container">
										<ul class="unit_content_list"
											*ngIf="(section.type === 'video' || section.type === 'Video')">
											<li *ngFor="let topic of section.metadata.topics; let i = index;"
												(click)="clickedVideoTopic(section, topic)"
												[ngClass]="getTopicStatus(section.sno, topic.id, this.userProgress.sections) && activeVideo(topic.id)">
												<!-- <img src="{{ topic.thumbnailSource }}" class="topic-image"
																					alt="Video Thumbnail"> -->
												<span class="topic-name">{{ topic.name }}</span>
												<!-- <span
																					*ngIf="userProgress && isTopicCompleted(section.sno, topic.id, this.userProgress.sections)"
																					class="completion-icon">&#10003;</span> -->
											</li>
										</ul>

										<!-- <div class="topic-name" *ngIf="section.type === 'download'">
												<li *ngFor="let document of section.metadata.documents; let i = index">
													Click to download <a (click)="downloadDocument(section.dfs, document.link)">{{ document.name }}</a>
												</li>
											</div> -->

										<div class="topic-name" *ngIf="(section.type === 'quiz' || section.type === 'Quiz')"
											(click)="clickedSection(section)"
											[ngClass]="getTaskStatus(section.sno, this.userProgress.sections).status && activeQuiz(section.sno)">
											{{ section.name }}
											<!-- <span *ngIf="userProgress && isSectionCompleted(section.sno, this.userProgress.sections)" class="completion-icon">&#10003;</span> -->
										</div>

										<ul class="unit_content_list"
											*ngIf="section.type === 'menu' || section.type === 'Menu'">
											<li *ngFor="let subSection of section.menu; let i = index;">
												<app-programs-sidenav-igx [section]="subSection" [progressId]="progressId"
													[selectedTopicId]="selectedTopicId"
													(selectedSectionEvent)="clickedSection($event)"
													[selectedSection]="selectedSection"
													(videoLocationEvent)="clickedVideoTopicInChild($event)" [index]="i"
													[userProgress]="userProgress"></app-programs-sidenav-igx>
											</li>
										</ul>
									</div>
								</ng-template>

								<!-- </igx-expansion-panel-body> -->
							</ngb-panel>
						</ngb-accordion>
						<!-- </article> -->
						<!-- </ng-template>
											</ngb-panel>

										</ngb-accordion> -->
					</div>
					<!-- <div *ngIf="isTranscript; else noTranscript" class="transcript-box">
						<div class="transcript-header">
							<div class="left-box">
								<mat-icon>terminal</mat-icon>
								<h6>Program overview</h6>
							</div>
							<div (click)="toggleIsTranscript()" class="right-box">
								<mat-icon>sort</mat-icon>
								<h6>Transcript</h6>
							</div>
						</div>
						<div #transcriptContent class="transcript-content">
							<ng-container *ngIf="isVttFileUrl; else noVttFile">
								<div class="vtt-text" [ngClass]="{'highlightText': block.isHighlighted}" *ngFor="let block of processedVttContent">
									  <div>{{ block.time }}</div>
									  <div>{{ block.text }}</div>
								</div>
							</ng-container>

							<ng-template #noVttFile>
								<div class="noVttFile">
									<img src="../../../../../assets/gifs/Flip_Blink_pose.gif" alt="">
									<p>Transcript not available for this video</p>
								</div>
							</ng-template>
						</div>
					</div> -->

					<!-- <ng-template #noTranscript> -->
						<!-- <div *ngIf="selectedSection && (selectedSection.type === 'video' || selectedSection.type === 'Video')" (click)="toggleIsTranscript()" class="transcript-btn">
							<mat-icon>sort</mat-icon>
							<h6>Transcript</h6>
						</div> -->

					<!-- </ng-template> -->


				</div>
			</div>
		</div>
	</div>
</div>
